module.exports = __webpack_public_path__ + "img/wheel-blur.6fbb23c3.svg";